import React from "react";
import { BRAND, REGISTER_URL, WHATSAPP_URL, WHATSAPP_DISPLAY, AUREA_WEBSITE } from "@/lib/site";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-[color:var(--paper-tint)] border-t border-[color:var(--line)]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <a
                        href={AUREA_WEBSITE}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-brand-link"
                        className="flex items-center gap-2 hover:opacity-90 transition-opacity"
                    >
                        <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[color:var(--maroon)] text-white font-serif text-lg">
                            A
                        </span>
                        <span className="font-serif text-xl tracking-tight text-[color:var(--navy)]" style={{ fontWeight: 500 }}>
                            {BRAND}
                        </span>
                    </a>
                    <p className="mt-4 text-sm text-slate-600 leading-relaxed max-w-md">
                        Practical research training and academic support for modern researchers.
                    </p>

                    <a
                        href={AUREA_WEBSITE}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-visit-aurea-btn"
                        className="btn-outline-navy mt-5 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm"
                    >
                        Visit Aurea Website
                        <ArrowUpRight className="h-4 w-4" />
                    </a>
                </div>

                <div>
                    <div className="font-mono-label text-slate-500">Registration</div>
                    <a
                        href={REGISTER_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-register-link"
                        className="mt-3 inline-block text-[color:var(--navy)] font-serif text-lg underline underline-offset-4 hover:text-[color:var(--maroon)]"
                    >
                        Open Google Form →
                    </a>
                    <div className="mt-4 text-xs text-slate-500">
                        Complete the form to reserve your place.
                    </div>
                </div>

                <div>
                    <div className="font-mono-label text-slate-500">Contact</div>
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-whatsapp-link"
                        className="mt-3 inline-block text-[color:var(--navy)] font-serif text-lg underline underline-offset-4 hover:text-[color:var(--maroon)]"
                    >
                        WhatsApp · {WHATSAPP_DISPLAY}
                    </a>
                    <div className="mt-4 text-xs text-slate-500">
                        Reach out for schedule updates and questions.
                    </div>
                </div>
            </div>

            <div className="border-t border-[color:var(--line)]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
                    <div>
                        © 2026{" "}
                        <a
                            href={AUREA_WEBSITE}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-copyright-link"
                            className="hover:text-[color:var(--maroon)] underline underline-offset-2"
                        >
                            {BRAND}
                        </a>
                        . All rights reserved.
                    </div>
                    <div>Qualitative Research Success Series · Cohort 1 · August 2026</div>
                </div>
            </div>
        </footer>
    );
}
